import './AppConnectorConnectToBlock.scss';

import React from 'react';
import { ConnectTo, PhSiteSettings } from "../../models/app-data-model";
import { Script } from 'gatsby';

export type AppConnectorConnectToBlockProps = {
  connectToData?: ConnectTo;
  phSiteSettings: PhSiteSettings;
};

const AppConnectorConnectToBlock: React.FC<AppConnectorConnectToBlockProps> = ({ connectToData, phSiteSettings}) => {
  const isEnabled = connectToData?.enabled;
  const apiSource = phSiteSettings.app_connector_api_data_source || "www.priorityhealth.com";

  return (
    <>
      {isEnabled && <div className='app-connector-connect-to-block'>
        <div data-app-config={connectToData?.app_data} data-api-source={apiSource}></div>
        <Script src={connectToData?.app_source_url}></Script>
      </div >
      }
    </>
  );
};

export default AppConnectorConnectToBlock;
